import React, { useState, useEffect, useContext } from 'react'
import { styled } from '@mui/material/styles'

import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
// import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
// import { Divider } from '@mui/material'
// import { getColor } from 'theme/colors'
// import { makeStyles } from '@mui/styles'
import Container from 'components/common/Container'
import Typography from 'components/common/Typography'
import PropTypes from 'prop-types'
import { Step } from '@mui/material'
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector'
import { makeStyles } from '@mui/styles'
import { getColor } from 'theme/colors'
import { SignupDataContext } from 'utils/provider/AuthContext'

const steps = ['Account Info', 'User Type', 'Company Info', 'Industry']

const useStyles = makeStyles({
  myClass: {
    '& .MuiStepLabel-label': {
      marginTop: '5px',
      fontWeight: 400,
      fontSize: 11,
    },
    zIndex: 111,
  },
  subTxt: {
    color: getColor('grey-g35'),
  },
  labelClass: {
    '& span': {
      zIndex: 1111,
    },
  },
})
export default function SignUpAccountSteps({ authenticationStep }) {
  const [active, setActive] = useState(0)
  const { signupData } = useContext(SignupDataContext)
  const classes = useStyles()
  useEffect(() => {
    if (authenticationStep === 4) {
      setActive(0)
    } else if (authenticationStep === 5) {
      setActive(1)
    } else if (authenticationStep === 6) {
      setActive(2)
    } else if (authenticationStep === 7) {
      setActive(3)
    }
  }, [authenticationStep])
  return (
    <Container flex direction="column" gap="20px 0">
      <Container width="430px">
        <Box sx={{ width: '100%' }}>
          <Stepper activeStep={active} alternativeLabel connector={<ColorlibConnector />} className={classes.myClass}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={ColorlibStepIcon} className={classes.labelClass}>
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </Container>
      {authenticationStep === 4 && (
        <Container>
          <Container textAlign="center">
            <Typography variant="h1" color={getColor('grey-g25')}>
              Welcome to PartsClub
            </Typography>
          </Container>
          <Container textAlign="center">
            <Typography variant="body1" className={classes.subTxt}>
              Let’s get your free PartsClub Membership set up.
            </Typography>
          </Container>
        </Container>
      )}

      {authenticationStep === 5 && (
        <Container>
          <Container textAlign="center">
            <Typography variant="h1" color={getColor('grey-g25')}>
              Who are you?
            </Typography>
          </Container>
          <Container textAlign="center">
            <Typography variant="body1" color={getColor('grey-g35')}>
              Select one option below
            </Typography>
          </Container>
        </Container>
      )}
      {authenticationStep === 6 && (
        <Container>
          <Container textAlign="center">
            <Typography variant="h1" color={getColor('grey-g25')}>
              Tell us about your company
            </Typography>
          </Container>
          <Container textAlign="center">
            <Typography variant="body1" color={getColor('grey-g35')}>
              Hey {signupData?.data?.firstName}, tell us a little about where you’re working.
            </Typography>
          </Container>
        </Container>
      )}

      {authenticationStep === 7 && (
        <Container>
          <Container textAlign="center">
            <Typography variant="h1" color={getColor('grey-g25')}>
              Which industry you are working in?
            </Typography>
          </Container>
          <Container textAlign="center">
            <Typography variant="body1" color={getColor('grey-g35')}>
              Let us know which industry you’re working in. Select one option
            </Typography>
          </Container>
        </Container>
      )}
    </Container>
  )
}

SignUpAccountSteps.propTypes = {
  authenticationStep: PropTypes.number,
  // onStepChange: PropTypes.func,
}
const ColorlibStepIconRoot = styled('div')(({ ownerState }) => ({
  backgroundColor: '#FFFFFF',
  color: '#9799B5',
  width: 30,
  height: 30,
  display: 'flex',
  borderRadius: '50%',
  border: '1.5px solid #9799B5',
  justifyContent: 'center',
  fontFamily: "'Lexend Deca'",
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  textAlign: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#FF8C1A',
    border: '1.5px solid #FF8C1A',
  }),
  ...(ownerState.completed && {
    color: '#FF8C1A',
    border: '1.5px solid #FF8C1A',
  }),
}))
function ColorlibStepIcon(props) {
  const { active, completed, className } = props

  const icons = {
    1: <div key="1">1</div>,
    2: <div key="2">2</div>,
    3: <div key="3">3</div>,
    4: <div key="4">4</div>,
  }

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  )
}
ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
}

const ColorlibConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 13,
    left: 'calc(-54% + 18px)',
    right: 'calc(42% + 23px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#FF8C1A',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#FF8C1A',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 1,
    border: 0,
    backgroundColor: '#C3C5D5',
    borderRadius: 1,
  },
}))
